import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export const Icon = ({ icon, size, title, color, style, className }) => {
    return (_jsx(FontAwesomeIcon, { "data-testid": "font-awesome-icon-test-id", "aria-hidden": true, title: title, icon: icon, size: size, color: color, style: style, className: className }));
};
